/* eslint-disable react/prop-types */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { Button, Dropdown, Form } from 'react-bootstrap';
import { countryOptions } from './CurrencyInput';
import Flex from 'components/common/Flex';

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <Button
    className="w-100 bg-transparent border text-800 fw-normal rounded-3"
    ref={ref}
    onClick={e => {
      e.preventDefault();
      onClick(e);
    }}
  >
    <Flex justifyContent="between" alignItems="center">
      {children}
      <FontAwesomeIcon icon="angle-down" />
    </Flex>
  </Button>
));

function CurrencyDropdown({ selectedCurrency, setSelectedCurrency }) {
  const [searchInputValue, setSearchInputValue] = useState('');
  return (
    <Dropdown className="w-100">
      <Dropdown.Toggle
        as={CustomToggle}
        className="d-flex align-items-center bg-transparent text-700 border-0 shadow-none ps-0"
      >
        <div className="d-flex align-items-center">
          <img
            className="img-fluid"
            src={selectedCurrency.image}
            alt={selectedCurrency.value}
            style={{
              height: '40px',
              width: '40px'
            }}
          />
          <span className="fs-0 mx-2 fw-medium">{selectedCurrency.value}</span>
          <span className="fs--1">{selectedCurrency.label}</span>
        </div>
      </Dropdown.Toggle>
      <Dropdown.Menu className="py-2 overflow-scroll custom-dropdown-menu w-100">
        <div className="px-3 mt-2">
          <Form className="position-relative">
            <Form.Control
              type="search"
              placeholder="Search..."
              aria-label="Search"
              className="rounded-3 py-2 search-input"
              style={{ paddingLeft: '2.5rem' }}
              value={searchInputValue}
              onChange={({ target }) => setSearchInputValue(target.value)}
            />
            <FontAwesomeIcon
              icon="search"
              className="position-absolute text-400 search-box-icon"
              style={{ top: '14px', left: '1rem' }}
            />
          </Form>
        </div>

        {countryOptions.length && (
          <div>
            <p className="text-800 pt-2 mb-0 px-4">All currenciesÍ</p>
            {countryOptions?.map((country, index) => (
              <Dropdown.Item
                as="button"
                key={index}
                onClick={() => setSelectedCurrency(country)}
              >
                <div
                  className={`${
                    selectedCurrency.value === country.value &&
                    'bg-primary text-white'
                  } hover-bg-primary d-flex align-items-center py-2 px-3 rounded-3`}
                >
                  <img
                    className="img-fluid"
                    src={country.image}
                    alt={country.value}
                    style={{
                      height: '30px',
                      width: '30px'
                    }}
                  />

                  <span className="ms-2">
                    <span className="fs-0 fw-medium">{country.value}</span>{' '}
                    <span className="fs--1">{country.label}</span>
                  </span>
                </div>
              </Dropdown.Item>
            ))}
          </div>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default CurrencyDropdown;
